import React from 'react';
import PropTypes from 'prop-types';
import './Contacts.scss';

const Contacts = ({ lang }) => {
    return (
        <div className="contacts">
            <h6 className="contacts__title mb-1">Единый справочный центр</h6>
            <a className="contacts__phone" href="tel:74232790000">+7 (423) 279-0000</a>
            <address className="contacts__address mb-0 mt-1">
                г. Владивосток, ул. Гамарника, 3-Б
            </address>
            {lang &&
                <div className="row justify-content-center justify-content-sm-start mt-1">
                    <div className="col-auto">
                        <a className="link-flag" href="/en/">
                            <img src="img/flags/us.svg" alt="Флаг США" />
                        </a>
                    </div>
                    <div className="col-auto">
                        <a className="link-flag" href="/cn/">
                            <img src="img/flags/cn.svg" alt="Флаг Китая" />
                        </a>
                    </div>
                </div>
            }
        </div>
    );
};

export default Contacts;

Contacts.propTypes = {
    lang: PropTypes.bool,
};